import { NavigationGuard, Route } from 'vue-router';

import oauth from '@/plugins/oauth';
import i18n from '@/plugins/vue-i18n';

import { addGtmEvent, GTMEvent } from '@/helpers/gtm';
import { buildSiteUrl } from '@/helpers/external';

const checkAuthGuard: NavigationGuard = function(to, from, next) {
  const authorized = oauth.checkAuthorized();

  if (to.matched.some(record => record.meta.requiresAnon) && authorized) {
    return next({ name: 'main' });
  }

  if (to.matched.some(record => record.meta.requiresAuth) && !authorized) {
    return next({ name: 'main' });
  }

  next();
};

const passFromRouteGuard: NavigationGuard = function(to, from, next) {
  Object.assign(to.params, { from: from.name });

  next();
};

const trackLandingGuard = function(to: Route) {
  if (!to.matched.some(record => record.meta.impression)) {
    return;
  }

  addGtmEvent(GTMEvent.LANDING_IMPRESSION);
};

const legalRedirectGuard: NavigationGuard = function({ meta = {} }, from, next) {
  const { redirect } = meta;

  if (!redirect) {
    return next({ name: 'main' });
  }

  const link = buildSiteUrl(redirect, i18n.locale);

  window.location.replace(link);
};

export { checkAuthGuard, passFromRouteGuard, trackLandingGuard, legalRedirectGuard };
